module.exports = __webpack_public_path__ + "img/5@2x.15c1968f.png";